import React from 'react';
import KilometerSliderInputComponent from './KilometerSliderInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}
const KilometerSliderInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <KilometerSliderInputComponent question={question} />;
  }
};

export default KilometerSliderInputPicker;
